module.exports = "/static-assets/_next/static/images/Poloaroid-6-c296ccb96ed124365108cf6b01abf8d6.png";